var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRedo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.425 11.25C3.2125 11.25 2.17188 10.8563 1.30313 10.0688C0.434375 9.28125 0 8.3 0 7.125C0 5.95 0.434375 4.96875 1.30313 4.18125C2.17188 3.39375 3.2125 3 4.425 3H9.15L7.2 1.05L8.25 0L12 3.75L8.25 7.5L7.2 6.45L9.15 4.5H4.425C3.6375 4.5 2.95313 4.75 2.37188 5.25C1.79063 5.75 1.5 6.375 1.5 7.125C1.5 7.875 1.79063 8.5 2.37188 9C2.95313 9.5 3.6375 9.75 4.425 9.75H9.75V11.25H4.425Z",
    fill: "black",
    fillOpacity: 0.56
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRedo);
export default __webpack_public_path__ + "static/media/icon-redo.82d2cb726e641c49c84fba438bf101c6.svg";
export { ForwardRef as ReactComponent };